import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import languageReducer from "./features/languageSlice";
import appStateSlice from "./features/appStateSlice";
import authModalSlice from "./features/authModalSlice";
import globalLoadingSlice from "./features/globalLoadingSlice";
import userSlice from "./features/userSlice";
import expiredModalReducer from "./features/expiredModalSlice";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  expiredModal: expiredModalReducer,
  language: languageReducer,
  authModal: authModalSlice,
  globalLoading: globalLoadingSlice,
  appState: appStateSlice,
  user: userSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export default store;
